/* AS-Electronics · Sofortpreise für NEUE & VERSIEGELTE Geräte (Ankauf)
   Gilt nur für Zustand "Neuware / versiegelt" UND wenn die Kaufrechnung mit ins Paket kommt.
   Alles andere läuft weiter als persönliche Anfrage.

   Pflege: Preis ändern = Zahl ändern. Zeile löschen = für dieses Gerät kein Sofortpreis.
   Schlüssel Smartphone/Tablet:  "Typ|Marke|Modell|Speicher"
   Schlüssel MacBook:            "Laptop / MacBook|Apple|Modell|Chip|RAM|SSD"
   Grundlage (Stand 15.10.2026): Ankaufpreise der großen Ankäufer für "Neu" (ZOXS, handyverkauf.net)
   – unsere Preise liegen gleich oder darunter (meist ca. 90 %) – und verkaufte versiegelte Geräte
   bei eBay.de. Seltene MacBook-Ausstattungen: Basispreis + halber Apple-Aufpreis.
   iPhone 18 Pro / Pro Max am 30.10.2026 auf die besten Neu-Ankaufpreise (ZOXS, wirkaufens, Maconline) angehoben.
   Monatlich prüfen, im September (neue iPhones) sofort. */
window.AsAnkaufSofort = {
  stand: '30.10.2026',
  gueltigTage: 7,
  preise: {
    /* ---------- iPhone ---------- */
    'Smartphone|Apple|iPhone 18 Pro Max|256 GB': 1380,
    'Smartphone|Apple|iPhone 18 Pro Max|512 GB': 1610,
    'Smartphone|Apple|iPhone 18 Pro Max|1 TB': 1810,
    'Smartphone|Apple|iPhone 18 Pro Max|2 TB': 2070,
    'Smartphone|Apple|iPhone 18 Pro|256 GB': 1230,
    'Smartphone|Apple|iPhone 18 Pro|512 GB': 1380,
    'Smartphone|Apple|iPhone 18 Pro|1 TB': 1700,
    'Smartphone|Apple|iPhone 18 Pro|2 TB': 2240,
    'Smartphone|Apple|iPhone 17 Pro Max|256 GB': 930,
    'Smartphone|Apple|iPhone 17 Pro Max|512 GB': 1120,
    'Smartphone|Apple|iPhone 17 Pro Max|1 TB': 1300,
    'Smartphone|Apple|iPhone 17 Pro Max|2 TB': 1470,
    'Smartphone|Apple|iPhone 17 Pro|256 GB': 890,
    'Smartphone|Apple|iPhone 17 Pro|512 GB': 1060,
    'Smartphone|Apple|iPhone 17 Pro|1 TB': 1210,
    'Smartphone|Apple|iPhone Air|256 GB': 650,
    'Smartphone|Apple|iPhone Air|512 GB': 770,
    'Smartphone|Apple|iPhone Air|1 TB': 780,
    'Smartphone|Apple|iPhone 17|256 GB': 710,
    'Smartphone|Apple|iPhone 17|512 GB': 820,
    'Smartphone|Apple|iPhone 17e|128 GB': 490,
    'Smartphone|Apple|iPhone 17e|256 GB': 560,
    'Smartphone|Apple|iPhone 17e|512 GB': 650,
    'Smartphone|Apple|iPhone 16 Pro Max|256 GB': 860,
    'Smartphone|Apple|iPhone 16 Pro Max|512 GB': 1050,
    'Smartphone|Apple|iPhone 16 Pro Max|1 TB': 1210,
    'Smartphone|Apple|iPhone 16 Pro|128 GB': 720,
    'Smartphone|Apple|iPhone 16 Pro|256 GB': 760,
    'Smartphone|Apple|iPhone 16 Pro|512 GB': 810,
    'Smartphone|Apple|iPhone 16 Pro|1 TB': 1080,
    'Smartphone|Apple|iPhone 16 Plus|128 GB': 630,
    'Smartphone|Apple|iPhone 16 Plus|256 GB': 660,
    'Smartphone|Apple|iPhone 16 Plus|512 GB': 710,
    'Smartphone|Apple|iPhone 16|128 GB': 570,
    'Smartphone|Apple|iPhone 16|256 GB': 660,
    'Smartphone|Apple|iPhone 16|512 GB': 700,
    'Smartphone|Apple|iPhone 16e|128 GB': 440,
    'Smartphone|Apple|iPhone 16e|256 GB': 470,
    'Smartphone|Apple|iPhone 16e|512 GB': 490,
    'Smartphone|Apple|iPhone 15 Pro Max|256 GB': 640,
    'Smartphone|Apple|iPhone 15 Pro Max|512 GB': 690,
    'Smartphone|Apple|iPhone 15 Pro Max|1 TB': 800,
    'Smartphone|Apple|iPhone 15 Pro|128 GB': 520,
    'Smartphone|Apple|iPhone 15 Pro|256 GB': 670,
    'Smartphone|Apple|iPhone 15 Pro|512 GB': 770,
    'Smartphone|Apple|iPhone 15 Pro|1 TB': 780,
    'Smartphone|Apple|iPhone 15 Plus|128 GB': 470,
    'Smartphone|Apple|iPhone 15 Plus|256 GB': 550,
    'Smartphone|Apple|iPhone 15 Plus|512 GB': 640,
    'Smartphone|Apple|iPhone 15|128 GB': 440,
    'Smartphone|Apple|iPhone 15|256 GB': 560,
    'Smartphone|Apple|iPhone 15|512 GB': 580,

    /* ---------- Samsung ---------- */
    'Smartphone|Samsung|Galaxy S26 Ultra|256 GB': 640,
    'Smartphone|Samsung|Galaxy S26 Ultra|512 GB': 810,
    'Smartphone|Samsung|Galaxy S26 Ultra|1 TB': 1090,
    'Smartphone|Samsung|Galaxy S26+|256 GB': 630,
    'Smartphone|Samsung|Galaxy S26+|512 GB': 640,
    'Smartphone|Samsung|Galaxy S26|128 GB': 380,
    'Smartphone|Samsung|Galaxy S26|256 GB': 470,
    'Smartphone|Samsung|Galaxy S26|512 GB': 540,
    'Smartphone|Samsung|Galaxy S26 FE|128 GB': 340,
    'Smartphone|Samsung|Galaxy S26 FE|256 GB': 410,
    'Smartphone|Samsung|Galaxy S25 Ultra|256 GB': 590,
    'Smartphone|Samsung|Galaxy S25 Ultra|512 GB': 640,
    'Smartphone|Samsung|Galaxy S25 Ultra|1 TB': 820,
    'Smartphone|Samsung|Galaxy S25+|256 GB': 580,
    'Smartphone|Samsung|Galaxy S25+|512 GB': 590,
    'Smartphone|Samsung|Galaxy S25|128 GB': 380,
    'Smartphone|Samsung|Galaxy S25|256 GB': 440,
    'Smartphone|Samsung|Galaxy S25|512 GB': 540,
    'Smartphone|Samsung|Galaxy S25 Edge|256 GB': 370,
    'Smartphone|Samsung|Galaxy S25 Edge|512 GB': 430,
    'Smartphone|Samsung|Galaxy S25 FE|128 GB': 310,
    'Smartphone|Samsung|Galaxy S25 FE|256 GB': 390,
    'Smartphone|Samsung|Galaxy S25 FE|512 GB': 430,
    'Smartphone|Samsung|Galaxy Z Fold8|256 GB': 980,
    'Smartphone|Samsung|Galaxy Z Fold8|512 GB': 1120,
    'Smartphone|Samsung|Galaxy Z Fold8|1 TB': 1280,
    'Smartphone|Samsung|Galaxy Z Flip8|256 GB': 550,
    'Smartphone|Samsung|Galaxy Z Flip8|512 GB': 620,
    'Smartphone|Samsung|Galaxy A57|128 GB': 200,
    'Smartphone|Samsung|Galaxy A57|256 GB': 280,
    'Smartphone|Samsung|Galaxy A37|128 GB': 150,
    'Smartphone|Samsung|Galaxy A37|256 GB': 220,
    'Smartphone|Samsung|Galaxy A26|128 GB': 150,
    'Smartphone|Samsung|Galaxy A26|256 GB': 160,
    'Smartphone|Samsung|Galaxy A17|128 GB': 100,
    'Smartphone|Samsung|Galaxy A17|256 GB': 130,

    /* ---------- iPad (Preis = WLAN-Modell, gilt auch für Cellular) ---------- */
    'Tablet|Apple|iPad Pro 13 (M5)|256 GB': 1010,
    'Tablet|Apple|iPad Pro 13 (M5)|512 GB': 1210,
    'Tablet|Apple|iPad Pro 13 (M5)|1 TB': 1400,
    'Tablet|Apple|iPad Pro 13 (M5)|2 TB': 1530,
    'Tablet|Apple|iPad Pro 11 (M5)|256 GB': 770,
    'Tablet|Apple|iPad Pro 11 (M5)|512 GB': 840,
    'Tablet|Apple|iPad Pro 11 (M5)|1 TB': 940,
    'Tablet|Apple|iPad Pro 11 (M5)|2 TB': 1050,
    'Tablet|Apple|iPad Air 13 (M4)|128 GB': 630,
    'Tablet|Apple|iPad Air 13 (M4)|256 GB': 690,
    'Tablet|Apple|iPad Air 13 (M4)|512 GB': 900,
    'Tablet|Apple|iPad Air 13 (M4)|1 TB': 1000,
    'Tablet|Apple|iPad Air 11 (M4)|128 GB': 530,
    'Tablet|Apple|iPad Air 11 (M4)|256 GB': 540,
    'Tablet|Apple|iPad Air 11 (M4)|512 GB': 600,
    'Tablet|Apple|iPad Air 11 (M4)|1 TB': 670,
    'Tablet|Apple|iPad mini (A17 Pro)|128 GB': 350,
    'Tablet|Apple|iPad mini (A17 Pro)|256 GB': 450,
    'Tablet|Apple|iPad mini (A17 Pro)|512 GB': 590,
    'Tablet|Apple|iPad (11. Gen, A16)|128 GB': 300,
    'Tablet|Apple|iPad (11. Gen, A16)|256 GB': 390,
    'Tablet|Apple|iPad (11. Gen, A16)|512 GB': 450,

    /* ---------- MacBook ---------- */
    'Laptop / MacBook|Apple|MacBook Neo 13 (2026)|A18 Pro|8 GB|256 GB': 520,
    'Laptop / MacBook|Apple|MacBook Neo 13 (2026)|A18 Pro|8 GB|512 GB': 600,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|16 GB|512 GB': 970,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|16 GB|1 TB': 980,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|16 GB|2 TB': 1310,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|16 GB|4 TB': 1770,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|24 GB|512 GB': 1080,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|24 GB|1 TB': 1260,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|24 GB|2 TB': 1430,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|24 GB|4 TB': 1890,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|32 GB|512 GB': 1200,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|32 GB|1 TB': 1310,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|32 GB|2 TB': 1540,
    'Laptop / MacBook|Apple|MacBook Air 13 (2026)|M5|32 GB|4 TB': 2000,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|16 GB|512 GB': 1160,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|16 GB|1 TB': 1220,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|16 GB|2 TB': 1500,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|16 GB|4 TB': 1960,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|24 GB|512 GB': 1270,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|24 GB|1 TB': 1310,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|24 GB|2 TB': 1620,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|24 GB|4 TB': 2080,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|32 GB|512 GB': 1390,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|32 GB|1 TB': 1500,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|32 GB|2 TB': 1730,
    'Laptop / MacBook|Apple|MacBook Air 15 (2026)|M5|32 GB|4 TB': 2190,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|16 GB|512 GB': 1150,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|16 GB|1 TB': 1350,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|16 GB|2 TB': 1580,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|16 GB|4 TB': 2040,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|24 GB|512 GB': 1460,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|24 GB|1 TB': 1510,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|24 GB|2 TB': 1690,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|24 GB|4 TB': 2150,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|32 GB|512 GB': 1580,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|32 GB|1 TB': 1600,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|32 GB|2 TB': 1810,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2025)|M5|32 GB|4 TB': 2270,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|24 GB|1 TB': 1830,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|24 GB|2 TB': 1920,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|24 GB|4 TB': 2520,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|48 GB|1 TB': 2060,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|48 GB|2 TB': 2290,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|48 GB|4 TB': 2750,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|64 GB|1 TB': 2170,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|64 GB|2 TB': 2400,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Pro|64 GB|4 TB': 2860,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|36 GB|2 TB': 2670,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|36 GB|4 TB': 3130,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|48 GB|2 TB': 2840,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|48 GB|4 TB': 3300,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|48 GB|8 TB': 3990,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|64 GB|2 TB': 2950,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|64 GB|4 TB': 3410,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|64 GB|8 TB': 4100,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|128 GB|2 TB': 3410,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|128 GB|4 TB': 3870,
    'Laptop / MacBook|Apple|MacBook Pro 14 (2026)|M5 Max|128 GB|8 TB': 4560,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|24 GB|1 TB': 1960,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|24 GB|2 TB': 2190,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|24 GB|4 TB': 2650,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|48 GB|1 TB': 2260,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|48 GB|2 TB': 2420,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|48 GB|4 TB': 2880,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|64 GB|1 TB': 2300,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|64 GB|2 TB': 2530,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Pro|64 GB|4 TB': 2990,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|36 GB|2 TB': 2970,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|36 GB|4 TB': 3430,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|48 GB|2 TB': 3040,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|48 GB|4 TB': 3600,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|48 GB|8 TB': 4290,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|64 GB|2 TB': 3250,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|64 GB|4 TB': 3710,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|64 GB|8 TB': 4400,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|128 GB|2 TB': 3710,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|128 GB|4 TB': 4170,
    'Laptop / MacBook|Apple|MacBook Pro 16 (2026)|M5 Max|128 GB|8 TB': 4860
  }
};

/* Fehlende neue Modelle im Ankauf-Katalog ergänzen (MacBook Neo, Galaxy Z Fold8/Flip8,
   Galaxy S26 auch mit 128 GB). Kann entfallen, sobald sie in as-ankauf-katalog.js stehen. */
(function () {
  var K = window.AsAnkaufKatalog; if (!K) return;
  function hat(liste, n) { for (var i = 0; i < liste.length; i++) if (liste[i].n === n) return i; return -1; }
  if (K.MACBOOKS && hat(K.MACBOOKS, 'MacBook Neo 13 (2026)') === -1) {
    var neo = { n: 'MacBook Neo 13 (2026)', v: [{ chip: 'A18 Pro', cpu: '6-Core', gpu: '5-Core', ram: ['8 GB'], ssd: ['256 GB', '512 GB'] }] };
    var i = hat(K.MACBOOKS, 'MacBook Air 15 (2026)'); K.MACBOOKS.splice(i === -1 ? K.MACBOOKS.length : i + 1, 0, neo);
    var mac = K['Laptop / MacBook'] && K['Laptop / MacBook'].Apple;
    if (mac && hat(mac, neo.n) === -1) { var j = hat(mac, 'MacBook Air 15 (2026)'); mac.splice(j === -1 ? mac.length : j + 1, 0, { n: neo.n, s: undefined }); }
  }
  var sam = K.Smartphone && K.Smartphone.Samsung; if (!sam) return;
  var s26 = hat(sam, 'Galaxy S26'); if (s26 !== -1) sam[s26].s = ['128 GB', '256 GB', '512 GB'];
  [['Galaxy Z Fold8', 'Galaxy Z Fold7'], ['Galaxy Z Flip8', 'Galaxy Z Flip7']].forEach(function (p) {
    if (hat(sam, p[0]) !== -1) return; var a = hat(sam, p[1]);
    sam.splice(a === -1 ? sam.length : a, 0, { n: p[0], s: a === -1 ? ['256 GB', '512 GB', '1 TB'] : sam[a].s });
  });
})();
